import PropTypes from "prop-types";
import styled from "styled-components";

var Divider = styled.hr.withConfig({
  displayName: "Divider",
  componentId: "sc-8zfwll-0"
})(["background:", ";border:0;width:", ";height:2px;margin-top:16px;margin-bottom:32px;margin-left:", ";margin-right:", ";"], function (props) {
  return props.inverted ? "white" : props.theme[props.color];
}, function (props) {
  return props.fluid ? "100%" : "64px";
}, function (props) {
  return props.position === "left" ? 0 : "auto";
}, function (props) {
  return props.position === "right" ? 0 : "auto";
});

Divider.propTypes = {
  color: PropTypes.string,
  position: PropTypes.string,
  fluid: PropTypes.bool
};

Divider.defaultProps = {
  color: "gray",
  position: "center",
  fluid: false
};

export default Divider;